import { BarcodeFormat, getBarcodeFormat } from "@deliverr/barcode-utils";

export const isFNSKUBarcode = (barcode: string) => getBarcodeFormat(barcode, { strict: true }) === BarcodeFormat.FNSKU;

export const isFNSKUOrASINBarcode = (barcode: string) => getBarcodeFormat(barcode) === BarcodeFormat.FNSKU;
